import { AsyncValidatorFn } from '@angular/forms';
import { inject, Injectable } from '@angular/core';
import { PromoCodeApiClient } from 'app/core/api-clients';
import { debounceTime, first, map, of, switchMap } from 'rxjs';
import { isString } from 'lodash-es';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PromoCodeValidator {
    private readonly _promoCodeClient = inject(PromoCodeApiClient);
    private readonly _translateService = inject(TranslateService);

    validatorFn(errorKey = 'errorMessage'): AsyncValidatorFn {
        return control =>
            control.valueChanges.pipe(
                debounceTime(500),
                switchMap(() => {
                    const code = isString(control.value) ? control.value : null;
                    if (code == null)
                        return this._translateService.get('general.promoCodeRequired').pipe(m => of({ [errorKey]: m }));

                    return of(code).pipe(
                        debounceTime(500),
                        switchMap(v => this._promoCodeClient.checkIfCodeIsValid(v)),
                        switchMap(({ isValid, errorMessage }) =>
                            isValid
                                ? of(null)
                                : errorMessage
                                  ? of({
                                        [errorKey]: errorMessage,
                                    })
                                  : this._translateService.get('general.unknown').pipe(map(m => ({ [errorKey]: m })))
                        ),
                        first()
                    );
                }),
                first()
            );
    }
}
